var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, truncateWords } from '@shapeable/utils';
var cls = classNames('content-node');
import { breakpoints, theme } from '@shapeable/theme';
import { MarkdownContent } from '../elements/markdown-content';
import { ContentTitle } from '../elements/content-title';
import { useLang } from '../hooks/use-lang';
import { PlainLinkButton } from '../elements/plain-link-button';
import { LinkEmbedsProvider } from '../context/link-embed-components-context';
export var ContentNodeDefaultProps = {
  moreLabel: 'read more',
  showExpandLink: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: inherit;\n    line-height: 1.65em;\n    font-size: 1em;\n  "], ["\n    font-weight: inherit;\n    line-height: 1.65em;\n    font-size: 1em;\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 1em;\n  "], ["\n    font-size: 1em;\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", "em;\n    margin-bottom: 0.5em;\n  "], ["\n    font-size: ", "em;\n    margin-bottom: 0.5em;\n  "])), 16 / 15)
});
var ExpandLinkStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: ", "; \n  "], ["\n    margin-top: ", "; \n  "])), theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Content: styled(MarkdownContent)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Title: styled(ContentTitle)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  ExpandLink: styled(PlainLinkButton)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ExpandLinkStyles)
};
export var ContentNode = function (props) {
  var className = props.className,
    entity = props.entity,
    title = props.title,
    maxWords = props.maxWords,
    moreLabel = props.moreLabel,
    showExpandLink = props.showExpandLink,
    markdown = __rest(props, ["className", "entity", "title", "maxWords", "moreLabel", "showExpandLink"]);
  if (!entity) {
    return null;
  }
  var t = useLang();
  var hasMore = false;
  var text = entity.text && entity.text.replace(/\\/ig, '');
  var hasText = !!text;
  if (!hasText) {
    return null;
  }
  if (maxWords) {
    var truncatedText = truncateWords(text, {
      max: maxWords
    });
    hasMore = truncatedText.length !== text.length;
    text = "".concat(truncatedText).concat(hasMore && !showExpandLink && moreLabel ? " <b>".concat(t(moreLabel), "</b>") : '');
  }
  var _a = __read(React.useState(!hasMore), 2),
    isExpanded = _a[0],
    setIsExpanded = _a[1];
  var linkEmbeds = entity.linkEmbeds || [];
  var linkRichEmbeds = entity.linkRichEmbeds || [];
  return React.createElement(LinkEmbedsProvider, {
    linkEmbeds: linkEmbeds,
    linkRichEmbeds: linkRichEmbeds
  }, React.createElement(My.Container, {
    className: cls.name(className)
  }, title && React.createElement(My.Title, null, title), React.createElement(My.Content, __assign({}, markdown, {
    text: text
  })), hasMore && showExpandLink && !isExpanded && React.createElement(My.ExpandLink, {
    onClick: function () {
      return setIsExpanded(true);
    }
  }, t(moreLabel))));
};
ContentNode.cls = cls;
ContentNode.defaultProps = ContentNodeDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;